<template>
  <div class="footer">
    <div class="judicial-school">
      <div class="container footerwrap">
        <ul class="judicial-school-ul" v-for="(aa, z) in lists" :key="z">
          <h2 class="judicial-school-h2">{{ aa.name }}</h2>
          <li
            class="judicial-school-li cursor"
            v-for="(item, index) in aa.cont"
            :key="index"
            @click="topath(item.path)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul class="judicial-school-ul" style="width: 122px; margin-left: -10px;text-align: center;">
          <img
            src="../assets/img/qrcode.jpg"
            style="width: 100px; height: auto; "
          />
          <li class="judicial-school-li"
          style="
              text-align: center;
              margin-top: 8px;
              width: 106px;
            "
          >
            关注公众号
          </li>
        </ul>
        <ul
          class="judicial-school-ul"
          style="width: 122px; margin-left: -10px; margin-top: 26px;text-align: center;"
        >
          <img
            src="../assets/img/appcode.jpg"
            style="width: 106px; height: auto; "
            class=""
          />
          <li
            class="judicial-school-li"
            style="
              text-align: center;
              margin-top: 8px;
              width: 106px;
            "
          >
            进入小程序
          </li>
        </ul>
        <ul class="judicial-school-ul about-us">
          <h2 class="judicial-school-h2" style="padding-bottom: 3px">
            <a href="/pages/help/about.html" target="_blank">关于我们</a>
          </h2>
          <li class="judicial-school-li">邮编: 050011</li>
          <li class="judicial-school-li">邮箱: zxpmpt@163.com</li>
          <li class="judicial-school-li">客服专线: 18000601828</li>
          <li
            class="judicial-school-li"
            style="width: 200px; line-height: 18px"
          >
            公司地址: 河北省石家庄市长安区谈南路63号睿和中心商业写字楼2206室
          </li>
        </ul>
        <div style="clear: both"></div>
      </div>
    </div>
    <div style="margin:0 auto; padding:20px 0;text-align: center;">
        <img src="../assets/img/gongan.png" />
        <p style="display:inline-block;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;font-size: 14px;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010202003410" 
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#fff;font-size: 14px;">
          冀公网安备 13010202003410号 </a> 
          <el-divider  direction="vertical"></el-divider>
          <a target="_blank" href="https://beian.miit.gov.cn/"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#fff;font-size: 14px;">
          备案号：冀ICP备2022013873号-1
		  <!-- 冀ICP备2022013873号 -->
          </a> 
        </p>
		 	</div>
    <!-- <div class="container">
      <p class="sifa-foot-p">
        京公网安备：11010502033825 <el-divider  direction="vertical"></el-divider>
        备案号：京ICP备13044676号 <el-divider direction="vertical"></el-divider>
        网络科技股份有限公司
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "logotitle",
  props: {
    logo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [
        {
          name: "帮助中心",
          cont: [
            { name: "竞拍流程", path: "/help" },
            { name: "拍卖规则", path: "/help" },
            { name: "平台规则", path: "/help" },
            { name: "拍卖法", path: "/help" },
          ],
        },
        // {
        //   name: "支付帮助",
        //   cont: [
        //     { name: "如何报名交保证金", path: "/help" },
        //     { name: "交保遇到限额", path: "/help" },
        //     { name: "尾款如何支付", path: "/help" },
        //   ],
        // },
        {
          name: "常见问题",
          cont: [
            { name: "退还保证金", path: "/help" },
            { name: "悔拍不想要", path: "/help" },
            { name: "如何办理过户", path: "/help" },
          ],
        },
      ],
      form: {
        select: "",
        keyword: "",
      },
    };
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.footer {
  background: #333;
  font-size: 0;
  .footerwrap{
    display: flex;
    justify-content: space-between;
  }
  .judicial-school {
    border-top: 1px solid #d7d7d7;
    background: #fff;
  }
  .judicial-school-ul {
    float: left;
    margin: 30px 0 10px 50px;
    width: 165px;
    .judicial-school-h2 {
      font-size: 18px;
      color: #333;
      padding-left: 10px;
      height: 18px;
      line-height: 18px;
      padding-bottom: 10px;
    }
    .judicial-school-li {
      padding-left: 12px;
      margin-top: 10px;
      font-size: 14px;
      color: #666;
    }
    .about-us {
      width: 165px;
      border-left: 1px solid #d7d7d7;
      padding-left: 50px;
    }
  }
  .sifa-foot-p {
    color: #666;
    text-align: center;
    height: 56px;
    line-height: 56px;
    font-size: 12px;
    .el-divider{
      background: #666;
    }
  }
}
</style>
